export const zIndexes = {
  bottomNavigationInStaffApp: 1201,
  staffHeader: 1100,
};
